import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const DisabilityMobility = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26 22.172V21C26 18.585 24.279 16.565 22 16.101V10H23C23.552 10 24 9.552 24 9C24 8.448 23.552 8 23 8H12V7.125C12 5.402 10.598 4 8.875 4H5C4.448 4 4 4.448 4 5C4 5.552 4.448 6 5 6H8.875C9.495 6 10 6.505 10 7.125V12.253C6.553 13.143 4 16.279 4 20C4 24.411 7.589 28 12 28C16.411 28 20 24.411 20 20C20 19.31 19.912 18.639 19.747 18H21C22.654 18 24 19.346 24 21V22.172C22.836 22.585 22 23.696 22 25C22 26.654 23.346 28 25 28C26.654 28 28 26.654 28 25C28 23.696 27.164 22.585 26 22.172ZM12 26C8.692 26 6 23.308 6 20C6 16.692 8.692 14 12 14C15.308 14 18 16.692 18 20C18 23.308 15.308 26 12 26ZM12 12V10H20V16H18.924C17.538 13.611 14.955 12 12 12ZM25 26C24.449 26 24 25.551 24 25C24 24.449 24.449 24 25 24C25.551 24 26 24.449 26 25C26 25.551 25.551 26 25 26Z" />
	</svg>
);

export default DisabilityMobility;
